import ENDPOINTS from '../../../const/endpoints';
export const authorizedUsersGetCacheKey = ({ accountId, accountIdType }) => [`get-${ENDPOINTS.authorizedUsers}`, { accountId, accountIdType }];
